import { BOOLINT } from '../constants/App';
import { DELETE_MESHBOT } from '../constants/MeshbotConstant';
import { SYNC_OPERATION } from './buildListSyncCondition';

/**
 * Determines the sync operation type for a cloud MeshBot based on the API request payload.
 *
 * - If the payload has `delete: 1` — it's a DELETE operation.
 * - If the payload has a `uuid` — it's an UPDATE of an existing MeshBot.
 * - Otherwise — it's a CREATE of a new MeshBot.
 *
 * @param {Object} payload - The API request payload for the MeshBot operation.
 * @param {string} [payload.uuid] - UUID of the MeshBot (present for update/delete).
 * @param {number} [payload.delete] - Set to 1 when deleting a MeshBot.
 * @returns {string} One of {@link SYNC_OPERATION} values: 'create', 'update', or 'delete'.
 *
 * @example
 * getMeshBotOperation({ name: 'New bot' });           // => 'create'
 * getMeshBotOperation({ uuid: 'abc-123', name: '' }); // => 'update'
 * getMeshBotOperation({ uuid: 'abc-123', delete: 1 }); // => 'delete'
 */
export const getMeshBotOperation = (payload) => {
    if (payload?.[DELETE_MESHBOT] === BOOLINT.TRUE) {
        return SYNC_OPERATION.DELETE;
    }

    return payload?.uuid ? SYNC_OPERATION.UPDATE : SYNC_OPERATION.CREATE;
};
